import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useEntitlements } from "../lib/entitlements";
import { useAuth } from "../lib/auth";
import LockedFeature from "../components/LockedFeature";
import { Link } from "react-router-dom";

export default function DashOrders() {
  const ent = useEntitlements();
  const { business } = useAuth();
  const entitled = ent?.entitled?.orders;
  const isExternal = business.togo_mode === "external";
  const [orders, setOrders] = useState([]);
  const load = async () => {
    if (!entitled) return;
    try { const r = await api.get("/orders"); setOrders(r.data); } catch { toast.error("Load failed"); }
  };
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); /* eslint-disable-next-line */ }, [entitled]);

  const setStatus = async (id, status) => {
    try { await api.patch(`/orders/${id}?status=${status}`); load(); toast.success(`Order marked ${status}`); }
    catch { toast.error("Failed"); }
  };

  return (
    <div>
      {!entitled && <LockedFeature addonKey="orders" name="To-go Orders & Menu" description="Turn on To-go Orders to accept guest orders through your public menu page and send SMS pickup alerts. $8/month, cancel anytime." />}
      {entitled && isExternal && (
        <div className="paper-card p-6 mb-6 bg-[#C2D1C1]/40 border-[#1E3A2F]/20">
          <div className="overline mb-1">To-go mode: External</div>
          <p className="text-sm text-[#1E3A2F]">Your to-go orders go to <b>{business.togo_provider || "your existing site"}</b>. This page is for Built-in Lite orders only. <Link to="/dashboard/settings" className="underline">Change in Settings</Link>.</p>
        </div>
      )}
      {entitled && !isExternal && (<>
      <div className="overline">Kitchen</div>
      <h1 className="text-3xl mb-6">To-go orders &amp; callbacks</h1>
      <div className="paper-card overflow-hidden">
        <div className="grid grid-cols-12 px-6 py-3 overline border-b border-[#E1DFD5]">
          <div className="col-span-3">Customer</div><div className="col-span-4">Items</div><div className="col-span-2">Total</div><div className="col-span-1">Status</div><div className="col-span-2 text-right">Actions</div>
        </div>
        {orders.length === 0 && <div className="p-10 text-center text-[#5C6B61]">No orders yet.</div>}
        {orders.map((o) => (
          <div key={o.id} className="grid grid-cols-12 items-center px-6 py-4 border-b border-[#E1DFD5] last:border-0">
            <div className="col-span-3">
              <div className="font-medium">{o.customer_name}</div>
              <div className="text-xs text-[#5C6B61]">{o.phone}</div>
            </div>
            <div className="col-span-4 text-sm">
              {o.items && o.items.length > 0 ? o.items.map((i, ix) => (<div key={`${o.id}-${i.id || i.name || ix}`}>{i.qty}× {i.name}</div>)) : <span className="text-[#5C6B61]">{o.notes || "—"}</span>}
            </div>
            <div className="col-span-2 font-heading font-extrabold">${(o.total || 0).toFixed(2)}</div>
            <div className="col-span-1"><span className="tag tag-waiting">{o.status}</span></div>
            <div className="col-span-2 flex justify-end gap-2">
              {o.status !== "ready" && o.status !== "picked_up" && (
                <button data-testid={`order-ready-${o.id}`} onClick={() => setStatus(o.id, "ready")} className="btn-ghost !py-1.5 !px-3 text-xs">Mark ready</button>
              )}
              {o.status === "ready" && (
                <button data-testid={`order-done-${o.id}`} onClick={() => setStatus(o.id, "picked_up")} className="btn-ghost !py-1.5 !px-3 text-xs">Picked up</button>
              )}
            </div>
          </div>
        ))}
      </div>
      </>)}
    </div>
  );
}
